// Simple device detection
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

console.log(`Device: ${isMobile ? "Mobile" : "Desktop"}`)

// Wait for DOM to be fully loaded
document.addEventListener("DOMContentLoaded", () => {
  console.log("DOM loaded - initializing video handler")
  setupVideoScrollEffect()

  if (isMobile) {
    setupMobileVideoAutoplay()
  } else {
    setupDesktopVideoAutoplay()
  }
})

// Also try on window load (for images and resources)
window.addEventListener("load", () => {
  console.log("Window loaded - ensuring video playback")
  if (isMobile) {
    setupMobileVideoAutoplay()
  } else {
    setupDesktopVideoAutoplay()
  }
})

// Setup scroll effect
function setupVideoScrollEffect() {
  console.log("Setting up scroll effect")

  // Wait a bit for slideshow to initialize
  setTimeout(() => {
    const videoSections = document.querySelectorAll('.slideshow [data-type="video"]')
    console.log(`Found ${videoSections.length} video sections`)

    if (videoSections.length === 0) return

    // Create wrappers for scroll effect
    videoSections.forEach((section, index) => {
      // Skip if already wrapped
      if (section.parentNode.classList.contains("video-scroll-wrapper")) return

      console.log(`Adding scroll wrapper to video section ${index + 1}`)

      const wrapper = document.createElement("div")
      wrapper.className = "video-scroll-wrapper"

      // Minimal styling - don't interfere with existing layout
      wrapper.style.cssText = `
        transform-origin: center center;
        will-change: transform;
        overflow: visible !important;
      `

      // Different transitions for mobile vs desktop
      if (isMobile) {
        wrapper.style.transition = "transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
      } else {
        wrapper.style.transition = "transform 0.1s ease-out"
      }

      // Wrap the section
      section.parentNode.insertBefore(wrapper, section)
      wrapper.appendChild(section)

      // Remove borders
      removeBorders(section)
    })

    // Setup scroll listener
    setupScrollListener()
  }, 1000)
}

// Setup scroll listener
function setupScrollListener() {
  const videoWrappers = document.querySelectorAll(".video-scroll-wrapper")

  if (videoWrappers.length === 0) {
    console.log("No video wrappers found")
    return
  }

  console.log(`Setting up scroll listener for ${videoWrappers.length} wrappers`)

  const updateVideoScale = () => {
    const scrollY = window.scrollY
    const windowHeight = window.innerHeight

    // Different settings for mobile vs desktop
    let startPoint, endPoint, maxScale

    if (isMobile) {
      startPoint = windowHeight * 0.1
      endPoint = windowHeight * 0.7
      maxScale = 0.08 // Less dramatic on mobile
    } else {
      startPoint = windowHeight * 0.05
      endPoint = windowHeight * 0.5
      maxScale = 0.15 // More dramatic on desktop
    }

    let progress = 0
    if (scrollY > startPoint) {
      progress = Math.min((scrollY - startPoint) / (endPoint - startPoint), 1)
    }

    const scale = 1 - progress * maxScale

    videoWrappers.forEach((wrapper) => {
      wrapper.style.transform = `scale(${scale})`
    })
  }

  // Throttled scroll for smooth performance
  let ticking = false
  const requestTick = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateVideoScale()
        ticking = false
      })
      ticking = true
    }
  }

  window.addEventListener("scroll", requestTick, { passive: true })

  // Initial call
  updateVideoScale()
}

// Remove borders from elements
function removeBorders(container) {
  // Only remove borders, don't touch anything else
  const allElements = [container, ...container.querySelectorAll("*")]

  allElements.forEach((element) => {
    element.style.border = "none"
    element.style.outline = "none"
    element.style.boxShadow = "none"
  })
}

// Mobile-specific video autoplay
function setupMobileVideoAutoplay() {
  console.log("Setting up mobile video autoplay")

  // Find all animate elements that might be paused
  const animateElements = document.querySelectorAll('.slideshow [data-type="video"] animate-element[paused]')
  console.log(`Found ${animateElements.length} paused animate elements`)

  // Remove paused attribute to start animations
  animateElements.forEach((element, index) => {
    console.log(`Removing paused attribute from animate element ${index + 1}`)
    element.removeAttribute("paused")
  })

  // Find all videos
  const videos = document.querySelectorAll('.slideshow [data-type="video"] video')
  console.log(`Found ${videos.length} videos`)

  // Add mobile-friendly attributes
  videos.forEach((video, index) => {
    console.log(`Setting up video ${index + 1} for mobile autoplay`)

    // These are the critical attributes for iOS/Safari
    video.setAttribute("playsinline", "")
    video.setAttribute("webkit-playsinline", "")
    video.setAttribute("muted", "")
    video.muted = true

    // Set autoplay (the theme sets this to false)
    video.setAttribute("autoplay", "")
    video.autoplay = true

    // Try to play the video
    const playPromise = video.play()
    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        console.log(`Initial autoplay failed: ${error}`)

        // Setup touch event to play on first interaction
        document.addEventListener(
          "touchstart",
          () => {
            video.play().catch((e) => console.log("Play on touch failed"))
          },
          { once: true },
        )
      })
    }
  })

  // Make sure videos are visible
  const videoContainers = document.querySelectorAll('.slideshow [data-type="video"]')
  videoContainers.forEach((container) => {
    const mediaElement = container.querySelector(".banner__media")
    if (mediaElement) {
      mediaElement.style.opacity = "1"
      mediaElement.style.visibility = "visible"
    }
  })
}

// Desktop-specific video autoplay
function setupDesktopVideoAutoplay() {
  console.log("Setting up desktop video autoplay")

  // Find all animate elements that might be paused
  const animateElements = document.querySelectorAll('.slideshow [data-type="video"] animate-element[paused]')
  console.log(`Found ${animateElements.length} paused animate elements on desktop`)

  // Remove paused attribute to start animations
  animateElements.forEach((element, index) => {
    console.log(`Removing paused attribute from desktop animate element ${index + 1}`)
    element.removeAttribute("paused")
  })

  // Find all videos
  const videos = document.querySelectorAll('.slideshow [data-type="video"] video')
  console.log(`Found ${videos.length} desktop videos`)

  // Add desktop-friendly attributes
  videos.forEach((video, index) => {
    console.log(`Setting up video ${index + 1} for desktop autoplay`)

    // Desktop video attributes
    video.muted = true
    video.autoplay = true
    video.loop = true
    video.setAttribute("muted", "")
    video.setAttribute("autoplay", "")
    video.setAttribute("loop", "")

    // Remove any poster attribute
    video.removeAttribute("poster")

    // Make sure video is visible
    video.style.opacity = "1"
    video.style.visibility = "visible"

    // Try to play the video
    const playPromise = video.play()
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.log(`Desktop video ${index + 1} playing successfully`)
        })
        .catch((error) => {
          console.log(`Desktop video ${index + 1} autoplay failed: ${error}`)

          // Try again after user interaction
          document.addEventListener(
            "click",
            () => {
              video.play().catch((e) => console.log("Play on click failed"))
            },
            { once: true },
          )
        })
    }
  })

  // Hide any cover images or overlays
  const coverImages = document.querySelectorAll(
    '.slideshow [data-type="video"] .video-cover-image, .slideshow [data-type="video"] img:not(video)',
  )
  coverImages.forEach((img) => {
    img.style.display = "none"
    img.style.opacity = "0"
  })

  // Make sure video containers are visible
  const videoContainers = document.querySelectorAll('.slideshow [data-type="video"]')
  videoContainers.forEach((container) => {
    const mediaElement = container.querySelector(".banner__media")
    if (mediaElement) {
      mediaElement.style.opacity = "1"
      mediaElement.style.visibility = "visible"
    }
  })
}

// Add a click event listener to play videos on desktop
if (!isMobile) {
  document.addEventListener(
    "click",
    () => {
      console.log("Click detected - trying to play all desktop videos")

      const videos = document.querySelectorAll('.slideshow [data-type="video"] video')
      videos.forEach((video) => {
        if (video.paused) {
          video.play().catch((e) => console.log("Play on click failed"))
        }
      })
    },
    { once: true },
  )
}

// Add a touch event listener to play videos on mobile
if (isMobile) {
  document.addEventListener(
    "touchstart",
    () => {
      console.log("Touch detected - trying to play all mobile videos")

      const videos = document.querySelectorAll('.slideshow [data-type="video"] video')
      videos.forEach((video) => {
        if (video.paused) {
          video.play().catch((e) => console.log("Play on touch failed"))
        }
      })
    },
    { once: true },
  )
}
// Minimal CSS injection - only for scroll effect and borders
;(() => {
  const style = document.createElement("style")
  style.textContent = `
    /* Remove borders only */
    .slideshow [data-type="video"] *,
    .slideshow [data-type="video"] *::before,
    .slideshow [data-type="video"] *::after {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
    
    /* Scroll effect wrapper */
    .video-scroll-wrapper {
      overflow: visible !important;
      will-change: transform;
      transform-origin: center center;
      position: relative !important;
    }
    
    /* Desktop scroll effect */
    @media screen and (min-width: 768px) {
      .video-scroll-wrapper {
        transition: transform 0.1s ease-out;
      }
      
      /* Force video visibility on desktop */
      .slideshow [data-type="video"] video {
        opacity: 1 !important;
        visibility: visible !important;
      }
      
      /* Hide cover images on desktop */
      .slideshow [data-type="video"] .video-cover-image,
      .slideshow [data-type="video"] img:not(video) {
        display: none !important;
        opacity: 0 !important;
      }
    }
    
    /* Mobile scroll effect - smoother */
    @media screen and (max-width: 767px) {
      .video-scroll-wrapper {
        transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      }
      
      /* Force video visibility on mobile */
      .slideshow [data-type="video"] video {
        opacity: 1 !important;
        visibility: visible !important;
      }
      
      /* Hide cover images on mobile */
      .slideshow [data-type="video"] .video-cover-image,
      .slideshow [data-type="video"] img:not(video) {
        display: none !important;
        opacity: 0 !important;
      }
    }
  `
  document.head.appendChild(style)
})()

// Try to play videos again after a delay
setTimeout(() => {
  console.log("Delayed video play attempt")

  const videos = document.querySelectorAll('.slideshow [data-type="video"] video')
  videos.forEach((video, index) => {
    if (video.paused) {
      console.log(`Trying to play video ${index + 1} after delay`)
      video.play().catch((e) => console.log(`Delayed play failed for video ${index + 1}`))
    }
  })
}, 2000)
